if (!customElements.get("klaviyo-notify")) {
  class KlaviyoNotify extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.companyId = this.dataset.companyId;
      this.listId = this.dataset.listId;
      this.searchUrlForEmail();
    }
    searchUrlForEmail() {
      let params = new URLSearchParams(document.location.search);
      let email = params.get("email");
      if (email) {
        this.querySelector("input").value = email;
      }
    }
    onSubmitHandler(e) {
      e.preventDefault();
      var e = new FormData(this.form),
        t = e.get("email");
      if (!this.validateEmail(t)) return this.showMessage("error-email"), !1;
      t = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2025-04-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED",
                        },
                      },
                    },
                    email: "" + t,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: this.listId,
                },
              },
            },
          },
        }),
      };
      this.sendRequest(t);
    }
    sendRequest(e) {
      const t = this;
      fetch(
        "https://a.klaviyo.com/client/subscriptions?company_id=" +
          this.companyId,
        e
      )
        .then((e) => {
          202 === e.status ? t.showMessage("success") : t.showMessage("error");
        })
        .catch((e) => {
          console.error(e), t.showMessage("error");
        });
    }
    validateEmail(e) {
      return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        e
      );
    }
    showMessage(e) {
      document
        .querySelector(".notify-message__" + e)
        .classList.remove("hidden"),
        setTimeout(() => {
          document.querySelector(".notify-message__" + e) &&
            document
              .querySelector(".notify-message__" + e)
              .classList.add("hidden");
        }, 6e3);
    }
  }
  customElements.define("klaviyo-notify", KlaviyoNotify);
}
